"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.staticRenderFns = exports.render = void 0;
var render = exports.render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", {
    staticStyle: {
      display: "inline-flex"
    },
    on: {
      click: _vm.onClick
    }
  }, [_vm._t("default", function () {
    return [_c("a-button", _vm._b({
      attrs: {
        loading: _vm.loading,
        icon: "download"
      }
    }, "a-button", _vm.$attrs, false), [_vm._v(_vm._s(_vm.title))])];
  })], 2);
};
var staticRenderFns = exports.staticRenderFns = [];
render._withStripped = true;